var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "selection 1",
    clipPath: "url(#clip0_1635_75211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5996 14.4746H2.84961C1.79961 14.4746 0.974609 13.6496 0.974609 12.5996V2.84961C0.974609 1.79961 1.79961 0.974609 2.84961 0.974609H12.5996C13.6496 0.974609 14.4746 1.79961 14.4746 2.84961V12.5996C14.4746 13.5746 13.5746 14.4746 12.5996 14.4746ZM2.84961 2.47461C2.62461 2.47461 2.47461 2.62461 2.47461 2.84961V12.5996C2.47461 12.8246 2.62461 12.9746 2.84961 12.9746H12.5996C12.8246 12.9746 12.9746 12.8246 12.9746 12.5996V2.84961C12.9746 2.62461 12.8246 2.47461 12.5996 2.47461H2.84961Z",
    fill: "#E6ECF3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.5996 17.0996H4.72461C4.27461 17.0996 3.97461 16.7996 3.97461 16.3496C3.97461 15.8996 4.27461 15.5996 4.72461 15.5996H15.5996V4.72461C15.5996 4.27461 15.8996 3.97461 16.3496 3.97461C16.7996 3.97461 17.0996 4.27461 17.0996 4.72461V15.5996C17.0996 16.4246 16.4246 17.0996 15.5996 17.0996Z",
    fill: "#E6ECF3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.97523 10.3492C6.82523 10.3492 6.60023 10.2742 6.45023 10.1242L4.20023 8.02422C3.90023 7.72422 3.90023 7.27422 4.12523 6.97422C4.42523 6.67422 4.87523 6.67422 5.17523 6.89922L6.90023 8.47422L10.1252 5.17422C10.4252 4.87422 10.8752 4.87422 11.1752 5.17422C11.4752 5.47422 11.4752 5.92422 11.1752 6.22422L7.42523 10.0492C7.35023 10.2742 7.12523 10.3492 6.97523 10.3492Z",
    fill: "#E6ECF3"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1635_75211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionSvg);
export default __webpack_public_path__ + "static/media/SelectionSvg.fb656ec40b2151a7fa98433df012ad8e.svg";
export { ForwardRef as ReactComponent };